import * as React from 'react';

import { PageTitle } from '../pages/pageTitle';

import { NotificationsTableContainer } from './table/notificationsTableContainer';

// eslint-disable-next-line react/prefer-stateless-function
export class NotificationsPage extends React.Component {
  public render() {
    return (
      <>
        <PageTitle displayTitle="Notifications" />
        <NotificationsTableContainer />
      </>
    );
  }
}
